module.exports = __webpack_public_path__ + "img/c1.43e58edb.png";